import { useLanguage } from '@/hooks/useLanguage';
import { supportedLanguages, languageNames, languageFlags, type SupportedLanguage } from '@/i18n';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

interface LanguageSwitcherProps {
  variant?: 'ghost' | 'outline';
  size?: 'sm' | 'default' | 'icon';
}

export function LanguageSwitcher({ variant = 'ghost', size = 'sm' }: LanguageSwitcherProps) {
  const { currentLang, switchLanguage } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className="gap-1.5">
          <Globe className="w-4 h-4" />
          <span className="text-sm">{languageFlags[currentLang]} {currentLang.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {supportedLanguages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => switchLanguage(lang)}
            className={currentLang === lang ? 'bg-accent' : ''}
          >
            <span className="mr-2">{languageFlags[lang]}</span>
            {languageNames[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
